
import React from 'react';

interface UpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const UpgradeModal: React.FC<UpgradeModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[130] flex items-center justify-center p-4 animate-glitch-in">
      <div className="absolute inset-0 bg-black/90 backdrop-blur-3xl" onClick={onClose} />
      <div className="relative glass p-10 rounded-3xl max-w-lg w-full border-red-500/30 shadow-[0_0_100px_rgba(239,68,68,0.1)] text-center overflow-hidden">
        {/* Background Text Decoy */}
        <div className="absolute inset-0 opacity-[0.02] pointer-events-none font-mono-cia text-[8px] leading-tight select-none rotate-12 scale-150">
          {Array.from({ length: 100 }).map((_, i) => (
            <div key={i}>CLEARANCE_LEVEL_RESTRICTED_PROTOCOL_GATEWAY_SECURE_NODE_0991_ENCRYPTED</div>
          ))}
        </div>

        <div className="classified-stamp mb-8 border-red-500 text-red-500 text-2xl scale-125 animate-pulse">CLEARANCE REJECTED</div>
        
        <h2 className="text-3xl font-bold mb-4 tracking-tighter text-white font-mono-cia uppercase">
          Insufficient Credentials
        </h2>
        
        <p className="text-slate-400 mb-8 leading-relaxed font-mono-cia text-sm">
          Node Focus 15 and 21 are part of the Restricted Consciousness Expansion Annex. 
          Your current biological identification (Subject DECLASSIFIED_G_83) does not have the required synchronization level.
        </p>
        
        <div className="grid gap-4">
          <button className="group relative w-full bg-red-600 hover:bg-red-500 py-5 rounded-xl font-bold transition-all shadow-lg text-lg uppercase tracking-widest overflow-hidden">
            <span className="relative z-10">Authorize Access ($19.99)</span>
            <div className="absolute inset-0 bg-white/10 translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
          </button>
          <button className="w-full bg-white/5 border border-white/10 hover:bg-white/10 py-5 rounded-xl font-bold transition-all text-sm uppercase tracking-widest text-slate-300">
            Request Physical Documents (Amazon)
          </button>
        </div>
        
        <button 
          onClick={onClose}
          className="mt-8 text-[10px] font-mono-cia text-slate-600 hover:text-slate-400 uppercase tracking-widest transition-colors"
        >
          &lt; Terminate Connection and Return &gt;
        </button>
      </div>

      <style>{`
        @keyframes glitch-in {
          0% { opacity: 0; transform: scale(0.95); filter: brightness(2); }
          10% { opacity: 1; transform: scale(1.02) skewX(20deg); }
          20% { transform: scale(1) skewX(-20deg); }
          30% { transform: skewX(0); }
          100% { opacity: 1; transform: scale(1); }
        }
        .animate-glitch-in {
          animation: glitch-in 0.4s ease-out;
        }
      `}</style>
    </div>
  );
};

export default UpgradeModal;
